import CallMadeRoundedIcon from "@mui/icons-material/CallMadeRounded";
import DiamondIcon from "@mui/icons-material/Diamond";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import useSmartAndRegularAssets from "../../../../../api/hooks/useSmartAndRegularAssets";
import CustomToolTip from "../../../../../components/CustomTooltip";
import LoadingIcon from "../../../../../components/LoadingIcon";
import iconMapping from "../../../../../icons/IconMapping";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { QueryParam } from "../../../../../utils/constants";
import { useEntities } from "../../../../stack/environment/hooks/useEntities";
const CriticalAssetNodeTooltip = ({ item, Icon }) => {
  const assetNode = item.nodeValue;
  const colors = useColors();

  const [entitiesInAsset, setEntitiesInAsset] = useState([]);
  const { trackEvent } = useAPI();
  const { isLoadingAll, regularAndActiveSmartAsset: assets } =
    useSmartAndRegularAssets(false);

  useEffect(() => {
    trackEvent("User viewed Critical Asset Node Tooltip");
  }, []);

  useEffect(() => {
    if (assets) {
      const asset = assets.find((asset) => asset.asset_id === assetNode.id);
      setEntitiesInAsset(asset?.entity_ids);
    }
  }, [assets]);

  const { useQueriesForEntities } = useEntities();

  let {
    entitiesAreLoading: fetchedEntitiesAreLoading,
    requestedEntities: entitiesInChosenAsset,
  } = useQueriesForEntities({ entityIDs: entitiesInAsset });

  const handleMoreInfoClick = () => {
    trackEvent(
      "User clicked on 'View Asset in New Tab' button in Critical Asset Node Tooltip"
    );
    let url = `/inventory/assets?${QueryParam.id}=${assetNode.id}`;
    window.open(url, "_blank");
  };

  return (
    <Box
      sx={{
        position: "relative",
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        minWidth: "200px",
        overflow: "auto",
        margin: "0 auto",
        boxSizing: "content-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <SvgToIcon
            IconLogo={Icon}
            style={{ color: "transparent", width: "16px" }}
          />
          <Typography variant="subtitle2">{assetNode.name}</Typography>
        </Box>
        <DiamondIcon sx={{ color: colors.primary_main, width: "16px" }} />
      </Box>
      <Divider sx={{ my: "6px" }} />
      {fetchedEntitiesAreLoading ? (
        <LoadingIcon size={25} />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Typography variant="overline">
            {entitiesInChosenAsset.length} Entities in total
          </Typography>

          <Box>
            {entitiesInChosenAsset?.slice(0, 10)?.map((entity) => {
              const IconType = iconMapping[entity.entity_type];

              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <CustomToolTip title={entity.entity_type}>
                    <SvgToIcon
                      IconLogo={IconType}
                      style={{
                        width: "16px",
                      }}
                    />
                  </CustomToolTip>
                  <Typography variant="caption">
                    {entity.display_name}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
      {
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            pt: 2,
          }}
        >
          <Button
            sx={{ textTransform: "none" }}
            onClick={handleMoreInfoClick}
            endIcon={
              <CallMadeRoundedIcon sx={{ color: colors.primary_main }} />
            }
          >
            <Typography
              variant="caption"
              sx={{
                textTransform: "none",
                color: colors.primary_main,
              }}
            >
              View Asset in New Tab
            </Typography>
          </Button>
        </Box>
      }
    </Box>
  );
};

export default CriticalAssetNodeTooltip;
